import { render, staticRenderFns } from "./_Elect.vue?vue&type=template&id=537206cf&"
import script from "./_Elect.vue?vue&type=script&lang=js&"
export * from "./_Elect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537206cf')) {
      api.createRecord('537206cf', component.options)
    } else {
      api.reload('537206cf', component.options)
    }
    module.hot.accept("./_Elect.vue?vue&type=template&id=537206cf&", function () {
      api.rerender('537206cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationService/_Elect.vue"
export default component.exports